import styled from 'styled-components';
import { primaryColor } from '../utils/styles';

export type StrongProps = {
  bold?: boolean;
};

export const Strong = styled.span<StrongProps>`
  color: ${primaryColor};
  font-weight: ${({ bold }) => (bold ? '700' : 'inherit')};
`;
